//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
export default {
  name: "material-info-list",
  components: {
    divSpan
  },
  data() {
    return {
      uploadUrl:process.env.API_ROOT,
      refresh:true,
      wrapperHeight: 0,
      allLoaded: false,
      config: {
        title: '物料信息库',
        url: 'api/material/page',
        fixRules: [],
        inputCondition: {
          placeholder: '物料编号/名称/ERP编号',
          searchCondition: 'key',
          rules: [{
            field: "matCode-matName-erpCode",
            option: "LIKE_ANYWHERE"
          }]
        },
      },
      searchData: {},
      list: []
    }
  },
  methods: {
    goDetail(id){
      this.$router.push('/material-info-view/'+id)
    },
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    }
  },
  mounted() {
    this.init();
    this.$refs.header.getlist();
  }
}



// WEBPACK FOOTER //
// ./src/page/material-info-library/material-info-list.vue